import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";
import "./client.css";

export default function RequireClientAuth({ children }) {
    const { user, isLoading, isSupabaseReady } = useClientAuth();
    const location = useLocation();

    if (!isSupabaseReady) {
        return children;
    }

    if (isLoading) {
        return (
            <div className="client-shell">
                <div className="client-card">
                    <div className="client-card__header">
                        <span className="client-card__badge">Modelerman</span>
                        <h1 className="client-card__title">Yükleniyor</h1>
                        <p className="client-card__subtitle">Oturum durumunuz doğrulanıyor...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/client/login" state={{ from: location }} replace />;
    }

    return children;
}
